<template>
<dl class="p-capture-form__item">
  <dt class="p-capture-form__item-label">
    <Text className="c-text-s__bold" text="つくる画像のタイプ"></Text>
  </dt>
  <dd class="p-capture-form__item-img-select">
    <div class="p-capture-form__item-img-type" :class="{'--selected': typeP1}" @click="selectThumbnailType">
      <Img className="c-img" src="/assets/img/img_prev-p1.png"></Img>
    </div>
    <div class="p-capture-form__item-img-type" :class="{'--selected': typeP2}" @click="selectThumbnailType">
      <Img className="c-img" src="/assets/img/img_prev-p2.png"></Img>
    </div>
  </dd>
</dl>
</template>

<script>
import Store from '../../store/index.js'
import Text from '@/components/atoms/Text.vue'
import Img from '@/components/atoms/Img.vue'

export default {
  components: {
    Text,
    Img
  },
  data () {
    return {
      typeP1: Store.state.thumbnailType.p1,
      typeP2: Store.state.thumbnailType.p2
    }
  },
  methods: {
    selectThumbnailType () {
      Store.commit('selectThumbnailType')
      this.typeP1 = Store.state.thumbnailType.p1
      this.typeP2 = Store.state.thumbnailType.p2
    }
  }
}

</script>

<style lang="scss" scoped>
.p-capture {
  &-form {
    &__wrapper {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
    }
    &__item {

      &-label {
        margin-bottom: 5px;
        padding-left: 15px;
      }
      &-img-select{
        display: flex;
      }
      &-img-type{
        max-width: 180px;
        width: 100%;
        height: 100%;
        box-shadow: $bs-default;
        &:hover{
          cursor: pointer;
        }
        &:first-child{
          margin-right: 2rem;
        }
        &.--selected {
          border: solid 3px $color_blue_dark;
          box-sizing: border-box;
          position: relative;

          &::after{
            content: '';
            width: 20px;
            height: 20px;
            border-radius: 10px;
            background: url('/assets/img/ic_check.png');
            background-size: cover;
            box-shadow: $bs-default;
            position: absolute;
            right: -10px;
            bottom: -10px;
          }
        }
      }
    }
  }
}
</style>
